import classNames from "classnames";
import React, { useState } from "react";
import { HiOutlineLogout, HiMenu, HiX } from "react-icons/hi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Dashboard_sidebar_bottom_Link,
  Dashboard_Sidebar_Link,
} from "../../lib/constant/navigation";

const LINK_BASE =
  "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200";

export default function Sidebar() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="flex">
      {/* Mobile Top Bar */}
      <div className="lg:hidden flex items-center justify-between bg-slate-900 text-white px-4 py-3 w-full fixed top-0 left-0 z-50 border-b border-slate-700/50">
        <div className="flex items-center gap-2.5">
          <img
            src="/zimage12.png"
            alt="Logo"
            className="h-7 w-7 object-contain rounded"
          />
          <span className="text-slate-100 text-base font-semibold tracking-tight">
            Zaptas Technologies
          </span>
        </div>
        <button
          className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-700/50 transition-colors"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? (
            <HiX className="w-6 h-6" />
          ) : (
            <HiMenu className="w-6 h-6" />
          )}
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={classNames(
          "bg-slate-900 text-slate-200 flex flex-col fixed lg:static top-0 left-0 h-screen w-56 z-40 border-r border-slate-700/50 transition-transform duration-300 ease-out",
          isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        )}
      >
        {/* Desktop Logo */}
        <div className="hidden lg:flex items-center gap-2.5 px-4 py-4 border-b border-slate-700/50 shrink-0">
          <img
            src="/zimage12.png"
            alt="Logo"
            className="h-6 w-6 object-contain rounded"
          />
          <span className="text-slate-100 text-sm font-semibold tracking-tight">
            Zaptas Technologies
          </span>
        </div>

        {/* Scrollable Menu */}
        <nav className="flex-1 overflow-y-auto py-4 px-2 mt-14 lg:mt-0">
          <ul className="space-y-1">
            {Dashboard_Sidebar_Link.map((item) => (
              <li key={item.key}>
                <SidebarLink
                  item={item}
                  onNavigate={() => setIsOpen(false)}
                />
              </li>
            ))}
          </ul>

          {/* Bottom Links */}
          <div className="mt-6 pt-4 border-t border-slate-700/50">
            <p className="px-3 mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
              Support
            </p>
            <ul className="space-y-1">
              {Dashboard_sidebar_bottom_Link.map((item) => (
                <li key={item.key}>
                  <SidebarLink
                    item={item}
                    onNavigate={() => setIsOpen(false)}
                  />
                </li>
              ))}
            </ul>
          </div>
        </nav>

        {/* Logout Fixed Bottom */}
        <div className="shrink-0 p-2 border-t border-slate-700/50">
          <button
            onClick={logout}
            className={classNames(
              LINK_BASE,
              "w-full text-slate-400 hover:text-red-400 hover:bg-red-500/10"
            )}
          >
            <HiOutlineLogout className="w-5 h-5 shrink-0" />
            Log out
          </button>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-30 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

function SidebarLink({ item, onNavigate }) {
  const { pathname, hash } = useLocation();
  const currentPath = pathname + (hash || "");
  const isActive =
    item.exact === false
      ? currentPath.startsWith(item.path)
      : currentPath === item.path;

  return (
    <Link
      to={item.path}
      onClick={onNavigate}
      className={classNames(
        LINK_BASE,
        isActive
          ? "bg-slate-700/60 text-white border-l-2 border-emerald-500 -ml-0.5 pl-3.5"
          : "text-slate-400 hover:text-slate-100 hover:bg-slate-700/40 border-l-2 border-transparent"
      )}
    >
      <span
        className={classNames(
          "shrink-0 text-lg",
          isActive ? "text-emerald-400" : "text-slate-500"
        )}
      >
        {item.icon}
      </span>
      <span className="truncate">{item.label}</span>
    </Link>
  );
}